$(document).ready(function () {
    'use strict';

    $('.js_scrollToSection').on('click', function(e) {
        e.preventDefault();

        var target = $(this).attr('href');

        $('html, body').animate({
            scrollTop: ($(target).offset().top) - 30
        }, 800);
    });
});